import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  margin: 20px 0px 0px 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  border-top: 1px solid var(--grisClaro);

  // Max Width Container
  #max-width-container {
    width: 100%;
    max-width: 1270px;
    margin: 40px 0px 0px 0px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .tag-container{
      // Tag
         div {
          margin: 0px 0px 20px 0px;
           padding: 8px 16px 8px 16px;
           display: flex;
           justify-content: center;
           align-items: center;
           align-content: center;
           background-color: #e5fff8;
           border-radius: 76px;
         }
     
         // Tag Text
         p {
           width: auto;
           margin: 0px 0px 0px 0px;
           font-weight: 600;
           font-size: 13px;
           text-align: center;
           color: #50c7a3;
           line-height: 154.7%;
         }
       }

  }

  // Title
  h3 {
    width: 100%;
    margin: 0px 0px 20px 0px;
    text-align: center;
  }

  h3 span {
    color: var(--azul100);
  }

  // Información Referidos Container
  #informacion-referidos-container {
    width: 100%;
    margin: 40px 0px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
  }

  // Información Referidos Container Div
  #texto-container,
  #imagen-container {
    margin: 0px 0px 0px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
  }

  // Texto Container
  #texto-container {
    flex-wrap: wrap !important;
    justify-content: center;
  }

  #texto-container {
    width: 80%;
    margin: 0px 0px 0px 0px;
    justify-content: center;
  }

  // Imagen Container Imagen
  #imagen-container img {
    border-radius: 10px;
    box-shadow: 0 5px 10px 0 rgba(0,0,0,0.2);
    height: 321px !important;
  }

  // Imagen Container Imagen
  #imagen-container div div {
    height: 321px !important;
  }

  // Texto Titulo
  #texto-titulo {
    width: 100%;
    margin: 16px;
    text-align: left;
    font-size: 18px;
    font-weight: 400;
    color: var(--negro);
    font-family: "Poppins", sans-serif;
    font-style: normal;
    line-height: 40px;
  }

  // Desplegable Container
  .desplegable-container {
    background-color: var(--grisClaro2);
    width: 70%;
    margin: 32px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    display: flex;
    justify-content: center;
    text-align: center;
    border-radius: 16px;
    transition: 0.2s all;
  }

  // Desplegable Container Abierto
  .desplegable-container-abierto {
    background-color: var(--grisClaro2);
    width: 0%;
    margin: 32px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    display: flex;
    justify-content: center;
    text-align: center;
    border-radius: 16px;
    transition: 0.2s all;
  }

  // Referir Botón
  #referir-boton {
    margin: 12px 0px 0px 0px;
    padding: 12px 24px 12px 24px;
    border-radius: 8px;
    color: var(--blanco);
    background-color: var(--azul60);
    cursor: pointer !important;
    transition: 0.2s;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    pointer-events: all !important;
  }

  // Referir Botón Hover
  #referir-boton:hover {
    background-color: var(--azul0);
  }

  .desplegable-container {
    background-color: #fff;
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Max Width Container
    #max-width-container {
      width: 1000px;
    }

    // Texto Titulo
    #texto-titulo {
      width: 100%;
      margin: 0px 0px 0px 0px;
      font0-size: 16px;
    }

    // Desplegable Container
    .desplegable-container {
      width: 85%;
    }

    // Desplegable Container Abierto
    .desplegable-container-abierto {
      width: 85%;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    // Max Width Container
    #max-width-container {
      width: 680px;
    }

    // Información Referidos Container
    #informacion-referidos-container {
      margin: 0px;
      flex-wrap: wrap;
      justify-content: center;
    }

    // Información Referidos Container Div
    #texto-container,
    #imagen-container {
      width: 80%;
      margin: 20px 0px 0px 0px;
      justify-content: center;
    }

    #texto-container {
      margin: 40px 0px 0px 0px;
    }

    #texto-container div {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      align-items: center;
      align-content: center;
    }

    // Texto Titulo
    #texto-titulo {
      text-align: center;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    // Max Width Container
    #max-width-container {
      width: 480px;
    }

    h3 {
      margin: 0px;
    }

    #texto-container div {
      margin-top: 10px;
    }

    // Desplegable Container
    .desplegable-container {
      width: 100%;
    }

    // Desplegable Container Abierto
    .desplegable-container-abierto {
      width: 100%;
    }

    // Imagen Container Imagen
    #imagen-container img {
      margin: 0px;
      display: none;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    // Max Width Container
    #max-width-container {
      width: 100%;
    }
  }

  // 525px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile525}) {
    // Title
    h3 {
      margin: 0px 0px 0px 0px;
    }

    // Imagen Container Imagen
    #imagen-container {
      display: none;
    }

    // Texto Titulo
    #texto-titulo {
      display: none;
    }

    #texto-container {
      margin: 32px 0px 0px 0px;
    }
  }
`;

export default Container;
